import type { LinkedWorkOrderTree } from "./plan-import/plan-import-types";
export type { LinkedWorkOrderTree } from "./plan-import/plan-import-types";

const number = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3 });
const date = (value: string | null) => value && Number.isFinite(Date.parse(value))
  ? new Intl.DateTimeFormat("tr-TR", { day: "2-digit", month: "short", timeZone: "Europe/Istanbul" }).format(new Date(value))
  : null;

export function ProductionWorkOrderTree({ tree }: { tree?: LinkedWorkOrderTree }) {
  if (!tree) return <small>Bağlı iş emri zinciri henüz alınmadı.</small>;
  const childCount = Math.max(0, tree.nodes.length - 1);
  return <details className="production-work-order-tree">
    <summary>{childCount} alt iş emri · {tree.complete ? "Zincir doğrulandı" : "Bağlantı kontrolü gerekli"}</summary>
    <ol aria-label={`${tree.rootWorkOrderNo} bağlı iş emri zinciri`}>
      {tree.nodes.map((node) => <li key={node.workOrderNo} style={{ paddingInlineStart: `${Math.min(node.depth, 6) * 18}px` }}>
        <span>
          <strong>{node.outputName || node.outputCode}</strong>
          <small>{node.outputCode} · {node.workOrderNo}{node.parentWorkOrderNo ? ` ← ${node.parentWorkOrderNo}` : " · Ana iş emri"}</small>
          <small>{[date(node.plannedStartAt), node.workCenterName || node.workCenterCode].filter(Boolean).join(" · ") || "Tarih ve iş merkezi kaydı yok"}</small>
        </span>
        <span>
          <small>Planlanan {number.format(node.plannedQuantity)}</small>
          <small>Üretilen {number.format(node.actualQuantity)}</small>
          <strong>Kalan {number.format(node.remainingQuantity)}</strong>
        </span>
      </li>)}
    </ol>
  </details>;
}
